const invertedMessages = {
  'External user classification started succesfully.':
    'external.dashboard.job.success',
  External: 'external.identities.tab.external',
  All: 'external.identities.tab.all',
};

export default invertedMessages;
